'use client';
import { useState } from 'react';
import { Content, NewsSearchBar, NoImage, TopTitle, NewsSkeleton, SearchEmpty } from '@/components';
import style from './style.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import { DateView } from '@/ui';
import { Pagination } from '@/components/shared';
import notImagePoster from '../../public/not-image.png';

const Pobeda = () => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const [searchResult, setSearchResult] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [searchStatus, setSearchStatus] = useState<boolean>(false);
  const handleLoading = (e: boolean) => {
    setLoading(e);
  };

  const handleSearch = (value: string) => {
    setSearchResult(value);
  };

  const handleData = (e: any) => {
    setData(e);
  };

  return (
    <div>
      <div className={style.topWrapper}>
        <TopTitle text="80 лет Великой Победы!" />
        <NewsSearchBar
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          link="/"
          onSearch={handleSearch}
        />
      </div>

      <Content>
        <div className={style.analitics}>
          <div className={style.list}>
            {searchStatus && <SearchEmpty />}
            {loading ? ( // Показываем скелетон только во время загрузки
              <NewsSkeleton count={5} />
            ) : data?.length > 0 ? ( // Если данные загружены и есть элементы
              data.map((elem: any) => {
                return (
                  <Link className={style.item} href={`/pobeda/${elem?.id}`} key={elem?.id}>
                    <div className={style.left}>
                      <div className={style.date}>
                        <DateView dateCreate={elem.date ?? elem.createdAt} />
                      </div>
                      {elem?.previewPicture?.url ? (
                        <Image
                          src={
                            process.env.NEXT_PUBLIC_APP_UPLOAD_URL +
                            (elem?.previewPicture?.formats?.large?.url || elem?.previewPicture?.url)
                          }
                          width={506}
                          height={332}
                          alt="poster"
                        />
                      ) : (
                        <NoImage width={506} height={332} image={notImagePoster} />
                      )}
                    </div>
                    <div className={style.right}>
                      <h1 className={style.title}>{elem?.title}</h1>
                      <p className={style.description}>
                        {elem?.shortText
                          ? elem?.shortText?.slice(0, 500)
                          : elem?.description.replace(/<[^>]*>/g, '').slice(0, 500)}
                        ...
                      </p>
                    </div>
                  </Link>
                );
              })
            ) : (
              <></>
            )}
          </div>
          <div className={style.pagination}>
            <Pagination
              setSearchStatus={setSearchStatus}
              isPagination
              setData={handleData}
              loader={handleLoading}
              link="pobedas"
              searchValue={searchResult}
              setSearchValue={setSearchValue}
            />
          </div>
        </div>
      </Content>
    </div>
  );
};

export default Pobeda;
